import Message from '@acri-tools/react-tools/components/Message/Message';
import Select from '@acri-tools/react-tools/components/Select/Select';
import { axiosErrorHandler } from '@acri-tools/react-tools/utils/global';
import request from '@acri-tools/react-tools/utils/request';
import React,{Component} from 'react';
import { connect } from 'react-redux';
import KPI2GraphMode from '../../../../components/KPI2GraphMode/KPI2GraphMode';
import { API_URL } from '../../../../_utils/config';
import { load_product_types } from '../../../../_utils/product_types';

interface Props{
    // REDUX
    product_types?:any
}
interface State{
    name: string,
    products: Array<any>,

    message: string,
    messageType: string

    loading: boolean

}

const _default = {
    name: '',
    products: []
}

class CreateKPI2GraphMode extends Component<Props, State>{
    
    constructor(props:Props){
        super(props);
        this.state={
            ..._default,

            loading:false,
            message: '',
            messageType: 'info'
        }
    }
    componentDidMount() {
        load_product_types()
    }
    render(){
        return (
            <>
                <div className="panel panel-big">
                    
                    <div className="title-1">Create new KPI 2 Graph mode</div>
                    <div className="subtitle-1">Create a new graph mode for KPI 2</div>
                    <br/>
                    <div className="form">
                        <div className="form-field">
                            <label>Name</label>
                            <input 
                                type="text" value={ this.state.name } placeholder={"Name"}
                                onKeyDown={this.onEnter} onChange={(e)=>{ this.setState({ name: e.target.value }) }}/>
                        </div>
                        <KPI2GraphMode
                            products={this.state.products}
                            on_add={()=>{ this.forceUpdate(); }}
                            update={(update:any)=>{ this.forceUpdate(); }}
                            remove={(idx)=>{
                                let { products } = this.state;
                                products.splice(idx, 1);
                                this.forceUpdate()
                            }}
                        />
                        <br/>
                        <br/>
                        <Message message={ this.state.message } type={ this.state.messageType }/>
                    </div>

                    <div className="centered">
                        <div className="custom-button green inverted inline alt" onClick={this.create}>CREATE GRAPH MODE</div>
                    </div>
                </div>
            </>
        );
    }

    remove = (idx:number)=>{
        let { products } = this.state;
        products.splice(idx,1);
        this.setState({ products });
    }


    onEnter = (e:any) =>{
        if(e.keyCode === 13){
            this.create();
        }
    }

    create = async() =>{
        if(!this.state.name)
            this.setState({ message: `Missing name`, messageType: 'warn' });
        // TODO check products
        
        this.setState({ loading:true });
        try{
            let res = await request(`${API_URL}/api/v1/kpi_2_graph_modes`,{
                method:'post',
                data: { 
                    name: this.state.name,
                    products: this.state.products
                }
            })
            this.setState({
                ..._default,
                products:[],
                message: res.data.message  ? res.data.message : 'An error has occured.',
                messageType: 'success',
            });
        }
        catch(e){
            axiosErrorHandler( e, { 
                functionName: 'add', 
                requestName: 'create_kpi_2_graph_mode',
            } )
            this.setState({
                message: e.response && e.response.data && e.response.data.error  ? e.response.data.error : 'An error has occured.',
                messageType: 'error'
            })
        }
        finally{
            this.setState({ loading:false });
        }        
    }
};


export default connect((state:any)=>{
    return {
        product_types: state.product_types
    }
})(CreateKPI2GraphMode);
